import { Controller } from '@hotwired/stimulus';

export default class ExtraCurricularCoursesFormController extends Controller {
  static targets = [
    'form',
    'tab',
    'checkbox',
    'row'
  ];

  static values = {
    url: String
  };

  toggleCheckbox(event) {
    this.formTarget.classList.add('opacity-50');

    const formData = new FormData(this.formTarget);

    for (const checkbox of this.checkboxTargets) {
      checkbox.disabled = true;
    }

    for (const row of this.rowTargets) {
      row.classList.add('unhover');
    }

    const tab = this.tabTargets.find(tab => tab.classList.contains('active'));

    formData.set('tab', tab.textContent);
    if (event.target.checked) {
      formData.set('select_course_id', event.target.value);
    }
    const url = new URL(this.urlValue, location.origin);

    url.search = new URLSearchParams(formData).toString();

    this.element.src = url.href;
    this.element.reload();
  }
}
